/* eslint-disable @typescript-eslint/no-explicit-any */
import { zodResolver } from '@hookform/resolvers/zod';
import { Box, Divider, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { IReportsRise } from '../../../../services/api/reports/ReportsServicesRise';
import { Loadin } from '../../../shared';

const dateString = z.string().refine((value) => {
    const date = new Date(value);
    return !isNaN(date.getTime());
}, {
    message: 'Data é obrigatório',
});

const GeneralSchema = z.object({
    motivo: z.string().min(2, { message: 'Motivo é obrigatório' }),
    empresa_executora: z.string().min(2, { message: 'Empresa é obrigatório' }),
    data_inspecao: dateString,
    data_dce: dateString,
    status_dce: z.string().min(2, { message: 'Status é obrigatório' }),
    responsavel: z.string().min(2, { message: 'Responsavel é obrigatório' }),
    art: z.string().min(2, { message: 'ART é obrigatório' }),
    orgao: z.string().min(2, { message: 'Orgão regulador é obrigatório' }),
    dpa: z.string().min(2, { message: 'DPA é obrigatório' }),
    cri: z.string().min(2, { message: 'CRI é obrigatório' }),
    classificacao: z.string().min(1, { message: 'Classificação é obrigatório' }),
});

interface IRegisterRise {
    onSubmit: (data: any) => void;
    setSubmitCallback: (callback: () => void) => void;
    dataRise: IReportsRise
}

export const GeneralRise: React.FC<IRegisterRise> = ({ onSubmit, setSubmitCallback, dataRise }) => {

    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        resolver: zodResolver(GeneralSchema),
        defaultValues: {
            motivo: '',
            empresa_executora: '',
            data_inspecao: '',
            data_dce: '',
            status_dce: '',
            responsavel: '',
            art: '',
            orgao: '',
            dpa: '',
            cri: '',
            classificacao: '',
        }
    });

    useEffect(() => {
        if (dataRise) {
            reset({
                motivo: dataRise.motivo ?? '',
                empresa_executora: dataRise.empresa_executora ?? '',
                data_inspecao: dataRise.data_inspecao ? new Date(dataRise.data_inspecao).toISOString().substring(0, 10) : '',
                data_dce: dataRise.data_dce ? new Date(dataRise.data_dce).toISOString().substring(0, 10) : '',
                status_dce: dataRise.status_dce ?? '',
                responsavel: dataRise.responsavel ?? '',
                art: dataRise.art ?? '',
                orgao: dataRise.orgao ?? '',
                dpa: dataRise.dpa ?? '',
                cri: dataRise.cri ?? '',
                classificacao: dataRise.classificacao ?? '',
            });
        }
    }, [dataRise, reset]);


    useEffect(() => {
        const submitHandler = handleSubmit(onSubmit);
        setSubmitCallback(() => {
            submitHandler();
        });
    }, [handleSubmit, onSubmit, setSubmitCallback]);

    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));

    if (!dataRise) {
        return (
            <Box>
                <Loadin />
            </Box>
        );
    }

    return (
        <form>
            <Box padding={2}>
                <Grid container marginBottom={2}>
                    <Grid item xs={12}>
                        <Typography variant='h5'>Geral</Typography>
                        <Divider />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true, }}
                            label='Motivo da inspeção especial'
                            id='motivo'
                            fullWidth
                            {...register('motivo')}
                            error={!!errors.motivo}
                            helperText={errors.motivo?.message}
                            required
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true, }}
                            label='Empresa executora'
                            id='empresa_executora'
                            fullWidth
                            {...register('empresa_executora')}
                            error={!!errors.empresa_executora}
                            helperText={(errors.empresa_executora ? errors.empresa_executora.message : '')?.toString()}
                            required
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true, }}
                            label='Data da inspeção'
                            id='data_inspecao'
                            fullWidth
                            type='date'

                            {...register('data_inspecao')}
                            error={!!errors.data_inspecao}
                            helperText={(errors.data_inspecao ? errors.data_inspecao.message : '')?.toString()}
                            required
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true, }}
                            label='Data da DCE'
                            id='data_dce'
                            fullWidth
                            type='date'
                            // value={dataRise?.data_dce}
                            {...register('data_dce')}
                            error={!!errors.data_dce}
                            helperText={(errors.data_dce ? errors.data_dce.message : '')?.toString()}
                            required
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true, }}
                            label='Status da DCE'
                            id='status_dce'
                            fullWidth
                            // value={dataRise?.status_dce}
                            {...register('status_dce')}
                            error={!!errors.status_dce}
                            helperText={(errors.status_dce ? errors.status_dce.message : '')?.toString()}
                            required
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true, }}
                            label='Responsável técnico'
                            id='responsavel'
                            fullWidth
                            // value={dataRise?.responsavel}
                            {...register('responsavel')}
                            error={!!errors.responsavel}
                            helperText={(errors.responsavel ? errors.responsavel.message : '')?.toString()}
                            required
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true, }}
                            label='ART (número)'
                            id='responsavel'
                            fullWidth
                            // value={dataRise?.art}
                            {...register('art')}
                            error={!!errors.art}
                            helperText={(errors.art ? errors.art.message : '')?.toString()}
                            required
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true, }}
                            label='Órgão fiscalizador'
                            id='responsavel'
                            fullWidth
                            // value={dataRise?.orgao}
                            {...register('orgao')}
                            error={!!errors.orgao}
                            helperText={(errors.orgao ? errors.orgao.message : '')?.toString()}
                            required
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true, }}
                            label='Dano Potencial Associado (DPA)'
                            id='responsavel'
                            fullWidth
                            // value={dataRise?.dpa}
                            {...register('dpa')}
                            error={!!errors.dpa}
                            helperText={(errors.dpa ? errors.dpa.message : '')?.toString()}
                            required
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true, }}
                            label='Categoria de Risco (CRI)'
                            id='responsavel'
                            fullWidth
                            // value={dataRise?.cri}
                            {...register('cri')}
                            error={!!errors.cri}
                            helperText={(errors.cri ? errors.cri.message : '')?.toString()}
                            required
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true, }}
                            label='Classificação (conforme órgão fiscalizador)'
                            id='responsavel'
                            fullWidth
                            // value={dataRise?.classificacao}
                            {...register('classificacao')}
                            error={!!errors.classificacao}
                            helperText={(errors.classificacao ? errors.classificacao.message : '')?.toString()}
                            required
                        />
                    </Grid>
                </Grid>
            </Box>
        </form>

    );
};
